// extracted by mini-css-extract-plugin
export default {"root":"classes_root__53Ixk","back-button":"classes_back-button__7D8uZ","icon":"classes_icon__9SNaT","title":"classes_title__B9kBn","footer":"classes_footer__icG6X"};